<!-- =========================================================================================
  File Name: send.vue
  Description: Money Send
========================================================================================== -->

<template>
  <div id="money-send">

    <vx-card title="提款银行">

      <div slot="actions">
        <vs-button size="small" color="success" type="filled" @click="add">添加新提款银行卡</vs-button>
      </div>

      <vs-table stripe :data="list" noDataText="暂无银行卡">
        <template slot="thead">
          <vs-th width="120">ID</vs-th>
          <vs-th width="300">银行名称</vs-th>
          <vs-th width="300">银行类型</vs-th>
          <vs-th width="200">状态</vs-th>
          <vs-th width="200">排序(数值越小越靠前)</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.name">{{item.name}}</vs-td>
            <vs-td :data="item.icon">{{bankList[item.icon]}}</vs-td>
            <vs-td :data="item.enable">{{item.enable == 1 ? '开启' : '关闭'}}</vs-td>
            <vs-td :data="item.order">{{item.order}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex !== -1 ? '更改银行信息' : '添加银行信息'" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.name" label="银行名称" />
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.icon" label="银行类型">
            <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in bankList" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.enable" label="状态">
            <vs-select-item value="1" text="开启" />
            <vs-select-item value="0" text="关闭" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.order" label="排序 (数值越小越靠前)" />
        </div>
      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      bankList: []
    }
  },
  components: {
    modifySiderBar
  },
  methods: {
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    add () {
      this.modifyIndex = -1
      this.modifyItem = { id: -1, icon: 'icbc', enable: 1, order: 0 }
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('money-bankSendDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该银行信息吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('money-bankSendDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    load() {
      this.$utils.post('money-bankSendList', { authKey: localStorage.getItem('authKey') }).then(res => {
        this.list = res
      })
    }
  },
  mounted () {
    this.load()

    // 获取银行卡列表
    this.$utils.post('money-bankList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.bankList = res
    })
  }
}
</script>
